import {ReactNode} from 'react';
import {Provider} from 'react-redux';

import {store} from '../store/store';

interface ReduxProviderProps {
  children: ReactNode;
}

export function ReduxProvider(props: ReduxProviderProps) {
  return <Provider store={store}>{props.children}</Provider>;
}
